import React, { useEffect } from "react";
import { Modal, Form, Input, Col, Row, message, Select } from "antd";
import { API_METHODS } from "../../../constants";
import useApi from "../../../hooks/useApi";
import { getClientConfig, getCreditors } from "../../../generalFunctions";

function AddPublication(props) {
  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi(
    "/config/publication",
    null,
    API_METHODS.POST
  );
  const [editResponse, editRequest] = useApi(
    `/config/publication/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT
  );
  const { account } = getClientConfig();

  useEffect(() => {
    if (response.data) {
      close(true);
      message.success("Publication added successfully.");
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      message.success("Publication updated successfully.");
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord]);

  const handleOk = () => {
    form.validateFields().then((values) => {
      if (selectedRecord) {
        editRequest(values);
      } else {
        request(values, API_METHODS.POST);
      }
    });
  };

  const handleCancel = () => {
    close();
  };

  return (
    <Modal
      title="Add Publication"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="publicationName"
              label="Publication Name"
              rules={[
                { required: true, message: "Publication Name is required." },
                {
                  max: 200,
                  message:
                    "Publication Name should be maximum of 200 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="creditorId"
              label="Creditor"
              rules={[{ required: true, message: "Creditor is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {getCreditors(account).map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.accountName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="classifiedCreditorId"
              label="Creditor for Classifieds"
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {getCreditors(account).map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.accountName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddPublication;
